import { type Allergen } from '@sg/graphql-schema';

import { type AllergenTypes } from '../setup/types';

// ─────────────────────────────────────────────────────────────────────────────

export function checkIfHasUnsavedPreferences(
  preferences: AllergenTypes,
  pendingPreferences: AllergenTypes,
) {
  const preferenceEntries = Object.entries(preferences);
  const checkIfValuesAreDifferent = checkIfValuesAreDifferentFactory(pendingPreferences); // prettier-ignore

  return preferenceEntries.some(checkIfValuesAreDifferent);
}

// ─────────────────────────────────────────────────────────────────────────────

function checkIfValuesAreDifferentFactory(pendingPreferences: AllergenTypes) {
  return function (preferenceEntry: PreferenceEntry) {
    const [kind, value] = preferenceEntry;
    const castedKind = kind as Allergen;

    return pendingPreferences[castedKind] !== value;
  };
}

// ─── Types ───────────────────────────────────────────────────────────────────

type PreferenceEntry = [string, boolean];
